import { Add, Cancel } from '@mui/icons-material';
import { Grid, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import { AppModels, AppState, Lang, Roles, UserRoles, apiPost, brandNewCompany, companySlice, hasErrors, saveModel, userSelector, userSlice } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSession } from '../../libraries/SessionProvider';
import { appStore } from '../../store';
import { CompanyLoader } from '../AppItems';
import { SuperSearchInput } from '../SuperSearchInput';

export const UserRightsView = (props: { userId: ModelId; }) => {
    const user = useSelector((state: AppState) => userSelector.selectById(state, props.userId));

    const { isSuperAdmin } = useSession();

    const [userCompanyId, setUserCompanyId] = React.useState<ModelId | null>(null);

    if (!user) return <></>;

    const onRemoveClick = async (userRole: UserRoles) => {
        const response = await apiPost('userRemoveRole', {
            userId: user.id,
            userRole: userRole
        });
        if (response) {
            appStore.dispatch(userSlice.actions.updateOne({ id: response.id, changes: response }));
        }
    };

    const onAddClick = async (role: Roles) => {
        const response = await apiPost('userAddRole', {
            userId: user.id,
            userRole: { role: role, relatedId: null }
        });
        if (response) {
            appStore.dispatch(userSlice.actions.updateOne({ id: response.id, changes: response }));
        }
    };
    const onClickSetCustomer = async () => {
        if (userCompanyId) {
            const response = await apiPost('userAddRole', {
                userId: user.id,
                userRole: { role: Roles.CUSTOMER, relatedId: userCompanyId }
            });
            if (response) {
                appStore.dispatch(userSlice.actions.updateOne({ id: response.id, changes: response }));
            }
        }
    };

    const onCreateUserCompany = async (companyName: string) => {
        const response = await saveModel(AppModels.companies, { ...brandNewCompany, name: companyName });
        if (!hasErrors(response)) {
            appStore.dispatch(companySlice.actions.upsertOne(response));
            setUserCompanyId(response.id);
        }
    };

    const [canSetCustomer] = React.useMemo(() => {
        return [
            user.roles.length == 0
        ];
    }, [user.roles]);

    return <Grid container sx={{ p: 2, m: 2 }}>
        <Grid item xs={12}>
            <List>
                {user.roles.length === 0 && <ListItem>Aucun droit</ListItem>}
                {user.roles.map((userRole, index) => <ListItem divider key={index}
                    secondaryAction={isSuperAdmin && <IconButton onClick={() => { onRemoveClick(userRole); }}><Cancel /></IconButton>}
                >
                    <RoleItem userRole={userRole} />
                </ListItem>)}
            </List>
            {isSuperAdmin && <>
                <Typography component='label'>Ajouter un droit d'accès</Typography>
                <List dense>
                    {[Roles.SUPERADMIN, Roles.FOREMAN, Roles.EMPLOYEE].map(p => <ListItem key={p}>
                        <IconButton disabled={!!user.roles.find(q => q.role === p)} onClick={() => onAddClick(p)}><Add /></IconButton>
                        <ListItemText primary={Lang('roles.' + p)} />
                    </ListItem>)}
                    <ListItem>
                        <IconButton disabled={!canSetCustomer || !userCompanyId} onClick={onClickSetCustomer}><Add /></IconButton>
                        <ListItemText
                            primary={Lang('roles.' + Roles.CUSTOMER)}
                            secondary={<SuperSearchInput
                                value={userCompanyId ? { type: AppModels.companies, id: userCompanyId } : undefined}
                                textfieldProps={{ disabled: canSetCustomer, placeholder: 'Entreprise' }}
                                filter={[AppModels.companies]}
                                onItemSelected={(_type: AppModels, id: ModelId, _data: any) => {
                                    setUserCompanyId(id);
                                }}
                                onCreate={onCreateUserCompany} />} />
                    </ListItem>
                </List></>}
        </Grid>
    </Grid>;
};


const RoleItem = (props: { userRole: UserRoles; }) => {

    if (props.userRole.role === Roles.CUSTOMER) {
        return <CompanyLoader id={props.userRole.relatedId} render={company => <ListItemText
            primary={Lang('roles.' + props.userRole.role)} secondary={company.name}></ListItemText>} />;
    } else {
        return <ListItemText
            primary={Lang('roles.' + props.userRole.role)}></ListItemText>;
    }
};
